import { Hash } from "@jamesgmarks/utilities";

export const CopiableText = (props: Hash) => {
  return (
    <>{props.children} {<button onClick={() => navigator.clipboard.writeText(props.children.toString())}>C</button>}</>
  );
};